import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AppHeader } from "@/components/landing/AppHeader";
import { AppsHero } from "@/components/landing/AppsHero";
import { AppsShowcase } from "@/components/landing/AppsShowcase";
import { LogoBand } from "@/components/landing/LogoBand";
import { AppContact } from "@/components/landing/AppContact";
import { AppFooter } from "@/components/landing/AppFooter";
import { CookieConsent } from "@/components/landing/CookieConsent";

function App() {
  return (
    <div className="min-h-screen bg-tt-black font-body text-tt-silver antialiased">
      <AppHeader />
      <main>
        <AppsHero />
        <AppsShowcase />
        <LogoBand />
        <AppContact />
      </main>
      <AppFooter />
      <CookieConsent />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
